export function currencyFormatter(
    value: number,
    locale: string = 'vi',
    currency: string = 'VND',
    symbol: string = 'đ'
): string {
    // Create a number formatter using 'Intl.NumberFormat' to format the number as currency.
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency', // Set the style to 'currency'.
        currency, // Specify the currency as 'USD'.
        currencyDisplay: 'code',
        // Remove trailing zeros manually since `trailingZeroDisplay` is not supported.
    });

    // Format the value and remove trailing zeros manually for integers.
    const formattedValue = formatter.format(value).replace(currency, symbol).replace(/\.00$/, '').replace(/\s/g, '');
    return `${formattedValue}`; // Append the custom currency symbol.
}
